import React from "react";

const ConfiguracaoPage = () => {
    return <div>Configuracao</div>
}

export default ConfiguracaoPage;